import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
import rootReducer from "../reducers"; // The combined reducer
import requestMiddleware from "../actions/requestMiddleware";
import { createLogger } from "redux-logger";

// Global persist config with localStorage
const persistConfig = {
  key: "scmroot",
  storage, // Persist in localStorage
  whitelist: ["auth", "sidebar", "tmw"], // These will be persisted in localStorage
};

// Wrap rootReducer with persistReducer using the global config
const persistedReducer = persistReducer(persistConfig, rootReducer);

function configureStoreProd(initialState) {
  const middlewares = [requestMiddleware(), thunk];

  const store = createStore(
    persistedReducer,
    initialState,
    compose(applyMiddleware(...middlewares))
  );

  const persistor = persistStore(store);
  return { store, persistor };
}

function configureStoreDev(initialState) {
  const middlewares = [requestMiddleware(), thunk];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares, createLogger()))
  );

  const persistor = persistStore(store);

  if (module.hot) {
    module.hot.accept("../reducers", () => {
      const nextRootReducer = require("../reducers").default;
      store.replaceReducer(nextRootReducer);
    });
  }

  return { store, persistor };
}

const configureStore =
  process.env.NODE_ENV === "production"
    ? configureStoreProd
    : configureStoreDev;

export default configureStore;
